import { render, staticRenderFns } from "./ItsContractCustomsApply.vue?vue&type=template&id=2ecd90d1&scoped=true&"
import script from "./ItsContractCustomsApply.vue?vue&type=script&lang=js&"
export * from "./ItsContractCustomsApply.vue?vue&type=script&lang=js&"
import style0 from "./ItsContractCustomsApply.vue?vue&type=style&index=0&id=2ecd90d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd90d1",
  null
  
)

export default component.exports